export const homepageTitle = {
	accepted: 'The clock is ticking!',
	default: 'Join the ongoing event:',
	invited: 'Great news!',
	noEvent: 'Be patient!',
};
